import { render, staticRenderFns } from "./adminOwnerDetail.vue?vue&type=template&id=7ff8df9a&scoped=true"
import script from "./adminOwnerDetail.vue?vue&type=script&lang=js"
export * from "./adminOwnerDetail.vue?vue&type=script&lang=js"
import style0 from "./adminOwnerDetail.vue?vue&type=style&index=0&id=7ff8df9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff8df9a",
  null
  
)

export default component.exports